/* "Sent manually" — record how a reminder went out (channel + short note) so history is truthful while the template is unavailable. */
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { err } from "./arDeskParts";

export const CHANNELS = [["WHATSAPP_DEPARTMENT_PHONE", "WhatsApp — Accounts phone"], ["WHATSAPP_PERSONAL", "WhatsApp — personal phone"], ["EMAIL", "E-mail"], ["PHONE_CALL", "Phone call"], ["SMS", "SMS"], ["IN_PERSON", "In person"], ["OTHER", "Other"]];

export function ManualSendDialog({ r, onClose, onDone }) {
  const [channel, setChannel] = useState("WHATSAPP_DEPARTMENT_PHONE");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/ar-desk/followups/${r.id}/manual-followup`, { channel, note: note.trim() || null }); setNote(""); onDone(r, data); } catch (e) { toast.error(err(e, "Could not record")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!r} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="ar-manual-dialog">
        <DialogHeader><DialogTitle>Record manual follow-up</DialogTitle><DialogDescription>{r?.company} · {r?.invoice_number} · {r?.whatsapp}. Counts as today's follow-up (cadence + duplicate protection).</DialogDescription></DialogHeader>
        <label className="block text-[12px]">How was it sent?
          <select value={channel} onChange={(e) => setChannel(e.target.value)} className="mt-1 h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-[13px]" data-testid="ar-manual-channel">{CHANNELS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></label>
        <label className="block text-[12px]">Short note (optional)
          <input value={note} onChange={(e) => setNote(e.target.value.slice(0, 200))} className="mt-1 h-9 w-full rounded-md border border-slate-200 px-2 text-[13px]" placeholder="e.g. spoke to Aakash, promised payment by Friday" data-testid="ar-manual-note" /></label>
        <div className="flex justify-end gap-2"><Button variant="outline" size="sm" onClick={onClose}>Cancel</Button><Button size="sm" disabled={busy} onClick={save} data-testid="ar-manual-save">{busy && <Loader2 className="mr-1 h-3 w-3 animate-spin" />}Record as sent</Button></div>
      </DialogContent>
    </Dialog>
  );
}
